import React from 'react';
import $ from 'jquery';

const Jquery = () => {
         const clickHandler=()=>{
        var settings = {
            "url": "https://mdev.thermalytix.com/api/login",
            "method": "POST",
            "timeout": 0,
            "headers": {
            "Content-Type": "application/json"
            },
            "data": JSON.stringify({
            "username": "hribcts@gmail.com",
            "password": "rmh@nsynp2020",
            "partnerid": "Remedi"
            }),
            "xhrFields":{
                "withCredentials":true
            },
            "crossDomain":true
            }; 
            
            $.ajax(settings).done(function (response) {
            console.log("thermalytix api called....",response);
            var input={
             "patientId":34,
             "visitId":"2",
              "age":34,
             "editPatient":false
            }
            //  let  urlstr = `https://mdev.thermalytix.com/patient/${response}?input=`+JSON.stringify(input);
          //  console.log("inside breastCancerScreening url"+ urlstr);
           // window.open(urlstr);
            });
            
    }

    return (
        <div>
            <button onClick={clickHandler} >login</button>
        </div>
    )
}

export default Jquery
